import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import QuoteNewPage from '@/pages/quote/quote-new-page'

const quoteNewSearchSchema = z.object({
  parentQuoteId: z.uuid().optional(),
  interventionId: z.uuid().optional(),
  technicianId: z.uuid(),
})

export type QuoteNewSearch = z.infer<typeof quoteNewSearchSchema>

export const Route = createFileRoute('/_quote-flow/org/$orgId/quotes/new')({
  component: QuoteNewPage,
  validateSearch: quoteNewSearchSchema,
})
